import { render, staticRenderFns } from "./PageLegal.vue?vue&type=template&id=c0fce3c8&scoped=true"
import script from "./PageLegal.vue?vue&type=script&lang=js"
export * from "./PageLegal.vue?vue&type=script&lang=js"
import style0 from "./PageLegal.vue?vue&type=style&index=0&id=c0fce3c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fce3c8",
  null
  
)

export default component.exports